import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Button, ButtonVariantOption, SubmitButton } from "@/components/Button";
import { UserConfigGetAPI } from "@/features/accountSettings/api/UserConfigAPI";
import { useApiClient } from "@/hooks/useApiClient";
import { usePropertyDetailOptionAmount } from "@/api/usePropertyDetailOptionAmount";

interface PropertyDetailOptionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  unitPrice?: number;
  target: "owner" | "all_matters";
}

const PropertyDetailOptionModal: React.FC<PropertyDetailOptionModalProps> = (
  props
) => {
  const { open, onClose, onConfirm, unitPrice, target } = props;
  const userConfig = UserConfigGetAPI();
  const { apiClient } = useApiClient();
  const { data: optionAmount } = usePropertyDetailOptionAmount(apiClient);
  const apiUnitPrice =
    target === "owner"
      ? optionAmount?.propertyDetailOptionUnitPriceOwner
      : optionAmount?.propertyDetailOptionUnitPriceAllMatters;
  const resolvedUnitPrice = unitPrice ?? apiUnitPrice;
  const isPriceHidden = userConfig?.isPriceHidden ?? true;
  const shouldShowPrice = !isPriceHidden && resolvedUnitPrice != null;

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      aria-labelledby="property-detail-option-modal-title"
      aria-describedby="property-detail-option-modal-description"
    >
      <DialogTitle id="property-detail-option-modal-title">
        {"課金確認"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="property-detail-option-modal-description"
          component="div"
        >
          {shouldShowPrice ? (
            <Typography>
              付与できた件数分に
              {resolvedUnitPrice.toLocaleString()}円
              のオプション料金がかかります。
            </Typography>
          ) : (
            <Typography>
              付与できた件数分にオプション料金がかかります。
            </Typography>
          )}
          <Typography>よろしいですか？</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
        <Button
          label="キャンセル"
          onClick={onClose}
          variant={ButtonVariantOption.Outlined}
        />
        <SubmitButton
          label="出力"
          timeout={120_000}
          onClick={(_, cancelLoading) => {
            Promise.resolve(onConfirm())
              .then(() => {
                onClose();
              })
              .catch(() => {
                // onConfirm側でエラー表示する想定のためここでは何もしない
              })
              .finally(() => {
                cancelLoading();
              });
          }}
          variant={ButtonVariantOption.Contained}
        />
      </DialogActions>
    </Dialog>
  );
};

export { PropertyDetailOptionModal };
